export interface ICompanyGroup {
  name: String
  description: String
  permissions: Array<String>
}
const rulesCompanyGroup = {
  name: 'required|min:1'
}
const initValue = {
  name: '',
  type: '',
  description: '',
  permissions: [],
  isAdmin: false
}
export default {
  rulesCompanyGroup,
  initValue
}
